import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-define-error',
  templateUrl: './define-error.component.html',
  styleUrls: ['./define-error.component.scss'],
  standalone:true,
  imports:[CommonModule]
})
export class DefineErrorComponent implements OnInit {
  public masternotselected: any;
  public errMsg: any;


  constructor(
    public dialogRef: MatDialogRef<DefineErrorComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: any,
  ) { }

  ngOnInit(): void {
   if (this.data) {
      this.masternotselected = true;
      this.errMsg  = this.data.Errornotmastertesslected;
    }
  }
  closeDialog() {
    this.dialogRef.close();
  }
  onclickclose() {
    this.closeDialog();
  }
}
